<template>
    <div class="share-element d-flex flex-wrap w-100 mb-2 mb-lg-3">
        <copy-link
            :videoUrl="getVideoURL"
        />
        <a v-for="element in getShareData"
            :key="element.id"
            href="#"
            @click.stop.prevent="url(element)"
            target="_blank">
            <div class="btn-icon-share-hover position-absolute">
                <img :src="element.imageHover" :alt="element.description" :title="element.description" width="40" class="img-fluid" />
            </div>
            <div class="btn-icon-share-hover btn-icon-share">
                <img :src="element.image" :alt="element.description" :title="element.description" width="40" class="img-fluid" />
            </div>
        </a>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import CopyLink from "./copy-link.vue";

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const getShareData = computed(() => {
    return store.getShareData;
});

const getVideoURL = computed(() => {
    if (store.getShareData.length > 0) {
        return store.getShareData[0].videoUrl;
    }
    return '';
});

// METHODS
const url = (element) => {
    let url = '';
    let weblinkIDEnc = store.getWeblinkIDEncore;
    url = `${element.urlToShare}${element.videoUrlEncode}`;
    if (weblinkIDEnc !== '') {
        url = url + '/' + weblinkIDEnc;
    }
    if (element.utmParameters != null) {
        url = `${url}&${element.utmParameters}`;
    }
    console.log(url);
    if (element.id !== 3) {
        window.open(url, '_blank');
    } else {
        const left = (screen.width - 570) / 2;
        const top = (screen.height - 570) / 2;
        const params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;

        window.open(url, "NewWindow", params);
    }
};

// LIFECYCLE HOOKS
</script>
